import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Wordmark } from "./Wordmark";

const NAV = [
  ["/work", "Work"],
  ["/services", "Services"],
  ["/pricing", "Pricing"],
  ["/agency", "Agency"],
  ["/faq", "FAQ"],
  ["/apply", "Apply"],
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const link = ({ isActive }) => `text-sm transition-colors ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`;
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10" data-testid="site-header">
      <div className="eb-container flex h-16 items-center justify-between">
        <Wordmark />
        <nav className="hidden md:flex items-center gap-8" aria-label="Main">
          {NAV.map(([to, label]) => (
            <NavLink key={to} to={to} className={link} data-testid={`nav-${label.toLowerCase()}`}>{label}</NavLink>
          ))}
          <Link to="/enquire" className="eb-btn-primary !py-2.5" data-testid="nav-start-project">Start a project</Link>
        </nav>
        <button className="md:hidden p-2 text-white" onClick={() => setOpen(!open)} aria-label="Toggle menu" aria-expanded={open} data-testid="mobile-menu-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden border-t border-white/10 bg-[#050505]" aria-label="Mobile" data-testid="mobile-menu">
          <div className="eb-container flex flex-col py-4 gap-1">
            {NAV.map(([to, label]) => (
              <NavLink key={to} to={to} onClick={() => setOpen(false)} className="py-3 text-lg font-display text-zinc-300 hover:text-white">{label}</NavLink>
            ))}
            <Link to="/enquire" onClick={() => setOpen(false)} className="eb-btn-primary mt-3">Start a project</Link>
          </div>
        </nav>
      )}
    </header>
  );
};
